import SPVDetails from "./issuerspv"
export default SPVDetails;
